import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import ProductHero from './ProductHero';
import ProductValues from './ProductValues';
import ProductWithMakers from './ProductWithMakers';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import { CARDS_CASE } from '../Const';
import WorksSection from '../modules/views/WorksSection';
import CtaBand from '../modules/views/CtaBand';
import PageMeta from '../modules/components/PageMeta';
import StructuredData from '../modules/components/StructuredData';

function Index() {
  return (
    <React.Fragment>
      <PageMeta
        description="埼玉県入間市の工務店・飯田建築有限会社。昭和42年の創業以来、建築士・エクステリアプランナー・インテリアコーディネーターが一貫して手がける新築・リフォームをご提案します。見積・相談は無料です。"
        path="/"
      />
      <StructuredData />
      <NavBar />
      <ProductHero />
      <ProductValues />
      <ProductWithMakers />
      <WorksSection cards={CARDS_CASE} />
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
